import { render } from "./ImageBlock.vue?vue&type=template&id=7213bd12&scoped=true&ts=true"
import script from "./ImageBlock.vue?vue&type=script&lang=ts"
export * from "./ImageBlock.vue?vue&type=script&lang=ts"

import "./ImageBlock.vue?vue&type=style&index=0&id=7213bd12&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7213bd12"]])

export default __exports__